import "./App.css";
import React, { useContext, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import StarekContext from "./context/StarekContext";
import {
  AuthGuardedRoute,
  PlantChosenGuardedRoute,
} from "./components/GuardedRoutes";

import AppLayout from "./layouts/AppLayout";
import MonoLayout from "./layouts/MonoLayout";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import SSOLogin from "./pages/SSOLogin";

import ChoosePlant from "./pages/ChoosePlant";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import { Devices } from "./pages/device/Devices";
import { Device } from "./pages/device/Device";
import { Zones } from "./pages/zone/Zones";
import { Users } from "./pages/user/Users";
import { User } from "./pages/user/User";
import { Roles } from "./pages/role/Roles";
import { Role } from "./pages/role/Role";
import { Shifts } from "./pages/shift/Shifts";
import { JobSchedules } from "./pages/JobSchedule/JobSchedules";
import { JobSchedule } from "./pages/JobSchedule/JobSchedule";
import { JobSchedule2 } from "./pages/JobSchedule/JobSchedule2";
import { Maintenance } from "./pages/Maintenance";
import { OnOffReport } from "./pages/OnOffReport";
import { EfficiencyReport } from "./pages/EfficiencyReport";
import { ProductionReport } from "./pages/ProductionReport";
import { Settings } from "./pages/setting/Settings";
import { Setting } from "./pages/setting/Setting";
import { DeviceProfiles } from "./pages/deviceProfile/DeviceProfiles";
import { DeviceProfile } from "./pages/deviceProfile/DeviceProfile";
import { Parts } from "./pages/part/Parts";
import { Webhook } from "./pages/webhook/Webhook";
import { Webhooks } from "./pages/webhook/Webhooks";
import { Cycle } from "./pages/cycle/Cycle";
import { Cycles } from "./pages/cycle/Cycles";
import { Test } from "./pages/Test";
import Reports from "./pages/report/Reports";
import Cookies from "js-cookie";

function StarekApp() {
  const starekContext = useContext(StarekContext);

  function parseJwt(token) {
    try {
      const base64Payload = token.split(".")[1];
      const jsonPayload = JSON.parse(
        typeof window === "undefined"
          ? Buffer.from(base64Payload, "base64").toString("utf-8")
          : atob(base64Payload)
      );
      return jsonPayload;
    } catch (e) {
      console.warn("[Auth Debug] Failed to parse JWT:", e);
      return null;
    }
  }

  return (
    <Router>
      <Routes>
        {/* Protected routes */}
        <Route
          path="/choose-plant"
          element={
            <AuthGuardedRoute>
              <MonoLayout>
                <ChoosePlant />
              </MonoLayout>
            </AuthGuardedRoute>
          }
        />
        <Route
          path="/"
          element={
            <AuthGuardedRoute>
              <PlantChosenGuardedRoute>
                <AppLayout>
                  <Dashboard />
                </AppLayout>
              </PlantChosenGuardedRoute>
            </AuthGuardedRoute>
          }
        />
        <Route
          path="/devices"
          element={
            <AuthGuardedRoute>
              <PlantChosenGuardedRoute>
                <AppLayout>
                  <Devices />
                </AppLayout>
              </PlantChosenGuardedRoute>
            </AuthGuardedRoute>
          }
        />
        <Route
          path="/device/:id"
          element={
            <AuthGuardedRoute>
              <PlantChosenGuardedRoute>
                <AppLayout>
                  <Device />
                </AppLayout>
              </PlantChosenGuardedRoute>
            </AuthGuardedRoute>
          }
        />
        <Route
          path="/zones"
          element={
            <AuthGuardedRoute>
              <PlantChosenGuardedRoute>
                <AppLayout>
                  <Zones />
                </AppLayout>
              </PlantChosenGuardedRoute>
            </AuthGuardedRoute>
          }
        />
        <Route
          path="/zones/:id"
          element={
            <AuthGuardedRoute>
              <PlantChosenGuardedRoute>
                <AppLayout>
                  <Zones />
                </AppLayout>
              </PlantChosenGuardedRoute>
            </AuthGuardedRoute>
          }
        />
        <Route
          path="/users"
          element={
            <AuthGuardedRoute>
              <PlantChosenGuardedRoute>
                <AppLayout>
                  <Users />
                </AppLayout>
              </PlantChosenGuardedRoute>
            </AuthGuardedRoute>
          }
        />
        <Route
          path="/user/:id"
          element={
            <AuthGuardedRoute>
              <PlantChosenGuardedRoute>
                <AppLayout>
                  <Users />
                </AppLayout>
              </PlantChosenGuardedRoute>
            </AuthGuardedRoute>
          }
        />
        <Route
          path="/reports"
          element={
            <AuthGuardedRoute>
              <PlantChosenGuardedRoute>
                <AppLayout>
                  <Reports />
                </AppLayout>
              </PlantChosenGuardedRoute>
            </AuthGuardedRoute>
          }
        />
        <Route
          path="/roles"
          element={
            <AuthGuardedRoute>
              <PlantChosenGuardedRoute>
                <AppLayout>
                  <Roles />
                </AppLayout>
              </PlantChosenGuardedRoute>
            </AuthGuardedRoute>
          }
        />
        <Route
          path="/role/:id"
          element={
            <AuthGuardedRoute>
              <PlantChosenGuardedRoute>
                <AppLayout>
                  <Roles />
                </AppLayout>
              </PlantChosenGuardedRoute>
            </AuthGuardedRoute>
          }
        />
        <Route
          path="/shifts"
          element={
            <AuthGuardedRoute>
              <PlantChosenGuardedRoute>
                <AppLayout>
                  <Shifts />
                </AppLayout>
              </PlantChosenGuardedRoute>
            </AuthGuardedRoute>
          }
        />
        <Route
          path="/shifts/:id"
          element={
            <AuthGuardedRoute>
              <PlantChosenGuardedRoute>
                <AppLayout>
                  <Shifts />
                </AppLayout>
              </PlantChosenGuardedRoute>
            </AuthGuardedRoute>
          }
        />
        <Route
          path="/job-schedules"
          element={
            <AuthGuardedRoute>
              <PlantChosenGuardedRoute>
                <AppLayout>
                  <JobSchedules />
                </AppLayout>
              </PlantChosenGuardedRoute>
            </AuthGuardedRoute>
          }
        />
        <Route
          path="/job-schedule/:id"
          element={
            <AuthGuardedRoute>
              <PlantChosenGuardedRoute>
                <AppLayout>
                  <JobSchedules />
                </AppLayout>
              </PlantChosenGuardedRoute>
            </AuthGuardedRoute>
          }
        />
        <Route
          path="/maintenance"
          element={
            <AuthGuardedRoute>
              <PlantChosenGuardedRoute>
                <AppLayout>
                  <Maintenance />
                </AppLayout>
              </PlantChosenGuardedRoute>
            </AuthGuardedRoute>
          }
        />
        <Route
          path="/on-off-report"
          element={
            <AuthGuardedRoute>
              <PlantChosenGuardedRoute>
                <AppLayout>
                  <OnOffReport />
                </AppLayout>
              </PlantChosenGuardedRoute>
            </AuthGuardedRoute>
          }
        />
        <Route
          path="/efficiency-report"
          element={
            <AuthGuardedRoute>
              <PlantChosenGuardedRoute>
                <AppLayout>
                  <EfficiencyReport />
                </AppLayout>
              </PlantChosenGuardedRoute>
            </AuthGuardedRoute>
          }
        />
        <Route
          path="/production-report"
          element={
            <AuthGuardedRoute>
              <PlantChosenGuardedRoute>
                <AppLayout>
                  <ProductionReport />
                </AppLayout>
              </PlantChosenGuardedRoute>
            </AuthGuardedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <AuthGuardedRoute>
              <PlantChosenGuardedRoute>
                <AppLayout>
                  <Settings />
                </AppLayout>
              </PlantChosenGuardedRoute>
            </AuthGuardedRoute>
          }
        />
        <Route
          path="/setting/:id"
          element={
            <AuthGuardedRoute>
              <PlantChosenGuardedRoute>
                <AppLayout>
                  <Settings />
                </AppLayout>
              </PlantChosenGuardedRoute>
            </AuthGuardedRoute>
          }
        />
        <Route
          path="/device-profiles"
          element={
            <AuthGuardedRoute>
              <PlantChosenGuardedRoute>
                <AppLayout>
                  <DeviceProfiles />
                </AppLayout>
              </PlantChosenGuardedRoute>
            </AuthGuardedRoute>
          }
        />
        <Route
          path="/device-profile/:id"
          element={
            <AuthGuardedRoute>
              <PlantChosenGuardedRoute>
                <AppLayout>
                  <DeviceProfiles />
                </AppLayout>
              </PlantChosenGuardedRoute>
            </AuthGuardedRoute>
          }
        />
        <Route
          path="/parts"
          element={
            <AuthGuardedRoute>
              <PlantChosenGuardedRoute>
                <AppLayout>
                  <Parts />
                </AppLayout>
              </PlantChosenGuardedRoute>
            </AuthGuardedRoute>
          }
        />
        <Route
          path="/parts/:id"
          element={
            <AuthGuardedRoute>
              <PlantChosenGuardedRoute>
                <AppLayout>
                  <Parts />
                </AppLayout>
              </PlantChosenGuardedRoute>
            </AuthGuardedRoute>
          }
        />
        <Route
          path="/webhooks"
          element={
            <AuthGuardedRoute>
              <PlantChosenGuardedRoute>
                <AppLayout>
                  <Webhooks />
                </AppLayout>
              </PlantChosenGuardedRoute>
            </AuthGuardedRoute>
          }
        />
        <Route
          path="/webhook/:id"
          element={
            <AuthGuardedRoute>
              <PlantChosenGuardedRoute>
                <AppLayout>
                  <Webhooks />
                </AppLayout>
              </PlantChosenGuardedRoute>
            </AuthGuardedRoute>
          }
        />
        <Route
          path="/cycles"
          element={
            <AuthGuardedRoute>
              <PlantChosenGuardedRoute>
                <AppLayout>
                  <Cycles />
                </AppLayout>
              </PlantChosenGuardedRoute>
            </AuthGuardedRoute>
          }
        />
        <Route
          path="/cycle/:id"
          element={
            <AuthGuardedRoute>
              <PlantChosenGuardedRoute>
                <AppLayout>
                  <Cycles />
                </AppLayout>
              </PlantChosenGuardedRoute>
            </AuthGuardedRoute>
          }
        />
        <Route
          path="/test"
          element={
            <AuthGuardedRoute>
              <PlantChosenGuardedRoute>
                <AppLayout>
                  <Test />
                </AppLayout>
              </PlantChosenGuardedRoute>
            </AuthGuardedRoute>
          }
        />
        {/* Public routes */}
        <Route
          path="/login"
          element={
            <MonoLayout>
              <Login />
            </MonoLayout>
          }
        />
        <Route
          path="/sso-authenticate"
          element={
            <MonoLayout>
              <SSOLogin />
            </MonoLayout>
          }
        />
        {/* Add other public routes here */}
      </Routes>
    </Router>
  );
}

export default StarekApp;
